// EC東京ショールーム識別処理
const NOTE_TAG = 'EC東京ショールーム経由';

function isEcTokyo() {
  const row = document.cookie.split('; ').find(r => r.startsWith('ec_tokyo_store='));
  return row ? decodeURIComponent(row.split('=')[1]) === 'true' : false;
}

class DrawerCartNote extends HTMLElement {
  constructor() {
    super();

    this.triggers = [
      this.querySelector(".giftnote__drawercart__addnote"),
      this.querySelector(".giftnote__body__close"),
      this.querySelector(".giftnote__overlay"),
    ];
    this.saveBtn = this.querySelector(".giftnote__save");

    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({
          note: document.getElementById("CartDrawer-note").value, // 空文字修正
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER),
    );

    this.onToggle = this.onToggle.bind(this); // bind修正
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input, select, textarea, [tabindex]";
    const focusableElements = () =>
      Array.from(
        this.querySelector(".giftnote__body").querySelectorAll(
          focusableElementsSelector,
        ),
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  // テキストエリアからEC東京タグを除去して表示
  syncTextarea() {
    const textarea = document.getElementById('CartDrawer-note');
    if (!textarea) return;
    if (textarea.value.includes(NOTE_TAG)) {
      textarea.value = textarea.value
        .replace('\n' + NOTE_TAG, '')
        .replace(NOTE_TAG, '')
        .trimEnd();
    }
  }

  // チェックアウトボタンにinterceptorを付与
  initCheckoutInterceptor() {
    const checkoutBtns = document.querySelectorAll(
      '[name="checkout"], a[href="/checkout"], .cart__checkout-button'
    );

    checkoutBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        if (!isEcTokyo()) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        try {
          const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
          const currentNote = cart.note || '';

          if (!currentNote.includes(NOTE_TAG)) {
            const newNote = currentNote ? currentNote + '\n' + NOTE_TAG : NOTE_TAG;
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: newNote })
            });
          }
        } catch(err) {
          console.warn('EC Tokyo note sync error', err);
        }

        window.location.href = '/checkout';
      });
    });
  }

  connectedCallback() {
    this.init();
    this.syncTextarea();          // 初期表示時にタグ除去
    this.initCheckoutInterceptor(); // チェックアウトinterceptor登録
  }

  onSave() {
    const textarea = document.getElementById("CartDrawer-note");
    const userNote = textarea.value;
    const note = isEcTokyo()
      ? (userNote ? userNote + '\n' + NOTE_TAG : NOTE_TAG)
      : userNote;

    const body = JSON.stringify({ note });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    this.onToggle();
  }

  onToggle() {
    const { focusableElements } = this.getFocusableElements();

    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      setTabindex(focusableElements(), "-1");
      this.triggers[0].focus();
    } else {
      this.setAttribute("open", true);
      setTabindex(focusableElements(), "0");
      this.syncTextarea(); // ドロワーを開くたびにタグ除去
      this.triggers[1].focus();
    }
  }

  init() {
    this.triggers.forEach((trigger) => {
      trigger?.addEventListener("click", (e) => {
        e.preventDefault();
        this.onToggle();
      });
    });

    this.saveBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.onSave();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.hasAttribute("open")) { // isOpen → hasAttribute に修正
          this.onToggle();
        }
      }

      if (isTabPressed) {
        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });
  }
}

customElements.define("drawer-cart-note", DrawerCartNote);